module.exports = __webpack_public_path__ + "img/stripe.8f0b343.png";